import React, { Component } from 'react'
import Link from '../utils/link'
import Seo from "../components/seo"
import SearchOverlay from '../components/search-overlay'

class NotFoundPage extends Component {

  render() {

    let list = []
    let canSearch = false

  	return (
  	<>
        <Seo title="404: Not found" />
        <SearchOverlay canSearch={canSearch} list={list} type="buy" postType="property" propertyType="residential" />
        <section className='basic basic--error'>
          <div className='basic__inner'>
            <div className='basic__content'> 
              <div className='basic__heading'> 
              	<h2>404 Error</h2>
              </div>
              <div>
                <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
                <Link to='/' className='btn'>Back home</Link>
              </div>
            </div>
          </div>
        </section>
      </>
    )
	}
}

export default NotFoundPage
